import * as React from 'react';
import { SidebarNavigation } from 'lib/components/SidebarNavigation';
import { FaBan } from 'react-icons/fa';
import { MdFolder, MdContacts } from 'react-icons/md';
import { ContactRoutes } from './routes';
import { useTranslation } from 'react-i18next';

export const Main = (): React.ReactElement => {
  const { t } = useTranslation();
  const iconSize = '24px';
  const items = [
    {
      title: t('Contacts'),
      icon: <MdContacts size={iconSize} />,
      path: `/contacts/list`,
    },
    {
      title: t('Groups'),
      icon: <MdFolder size={iconSize} />,
      path: `/contacts/groups`,
    },
    /* {
      title: 'Custom Fields',
      icon: <FaFileAlt size={iconSize} />,
      path: `/contacts/custom-fields`,
    },*/
    {
      title: t('Opt-Outs'),
      icon: <FaBan size={iconSize} />,
      path: `/contacts/opt-outs`,
    },
  ];

  return (
    <>
      <SidebarNavigation items={items} hasBack={false} />
      <ContactRoutes />
    </>
  );
};
